
import React from "react";

export default function NoDataEnergyCity() {
  return (
    <>
      <div className="v-title chartbox" style={{marginTop:"42px"}}>
        <div className="chartHGT">
          <div className="alert alert-danger no_data">records not found</div>
          <div style={{ height: "110px" }} ></div>
        </div>
      </div>
    </>
  );
}